import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ReservationformService } from "../reservationform/reservationform.service";
import { CustomerauthService } from "@foh/shared/auth/customerauth.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray
} from "@angular/forms";
import {
  emailValidator,
  phoneValidator,
  nameValidator
} from "@foh/shared/directives/app-validators";

@Component({
  selector: "app-guest-login",
  templateUrl: "./guest-login.component.html",
  styleUrls: ["./guest-login.component.scss"]
})
export class GuestLoginComponent implements OnInit {
  imageSrc: string = null;
  routeObs$: any;
  formid: any;
  form: FormGroup;
  loading: boolean=false;
  formSubmitted = false;
  constructor(
    private reservationformService: ReservationformService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2,
    private globals: Globals,
    public formBuilder: FormBuilder,
    public customerauthService:CustomerauthService
  ) {}

  ngOnInit() {
    this.createForm();
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.formid = params["token"];
      this.form.patchValue(
        {token : this.formid }
      );
      this.reservationformService
        .retrieveMetadata(params)
        .subscribe((response: any) => {
          this.renderer.addClass(document.body, response.metaData.cssclass);
          this.imageSrc =
            this.globals.UPLOADS + "logos/" + response.metaData.logo;
        });
    });
  }

  createForm() {
    this.form = this.formBuilder.group({
      token: ["", Validators.compose([Validators.required])],
      mobileno: ["", Validators.compose([Validators.required, phoneValidator])],
      upincode: ["", Validators.compose([Validators.required])]
    });
  }

  get f() {
    return this.form.controls;
  }

  save() {
    this.formSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    this.customerauthService
      .signinUser(this.form.value)
      .subscribe((response: any) => {
        this.loading = false;
        if(response.status){
          this.customerauthService.logInUser(response);
          this.router.navigate(["guest/myprofile/"+response.domain]);
        }
      });

  }
}
